export const sortOrders = (ordersToSort) => {
    return ordersToSort.sort((a, b) => {
        if (!a.orderTimestamp || !b.orderTimestamp) {
            return 1;
        }

        if (Number(a.orderTimestamp) > Number(b.orderTimestamp)) return 1;
        else return -1;
    });
}

export const sortCompleteOrders = (ordersToSort) => {
    return ordersToSort.sort((a, b) => {
        const aTime = a.statusHistory.find((item) => item.status === 'ACCEPTED');
        const bTime = b.statusHistory.find((item) => item.status === 'ACCEPTED');

        if (Number(aTime.eventCompletedTime) < Number(bTime.eventCompletedTime)) return 1;
        else return -1;
    });
}

export function isNotEmptyString(text) {
    return text !== undefined && text !== null && text.length > 0;
}